import { render, staticRenderFns } from "./ClienteNovo.vue?vue&type=template&id=3b1ea678&scoped=true"
import script from "./ClienteNovo.vue?vue&type=script&lang=js"
export * from "./ClienteNovo.vue?vue&type=script&lang=js"
import style0 from "./ClienteNovo.vue?vue&type=style&index=0&id=3b1ea678&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1ea678",
  null
  
)

export default component.exports